import store from "@/store";
import config from "@/config";
import axios from "axios";

let timer = null;
const DEFAULT_PING_INTERVAL_MS = 10000;
const DEFAULT_RETRY_MAX_MS = 120000;
const DEFAULT_REQUEST_TIMEOUT_MS = 1200;
let offlineRetryMs = getPingIntervalMs();

function isPingEnabled() {
  return config.spoolerPingEnabled !== false;
}

function getPingIntervalMs() {
  const interval = Number(config.spoolerPingIntervalMs);
  return Number.isFinite(interval) && interval > 0
    ? interval
    : DEFAULT_PING_INTERVAL_MS;
}

function getRetryMaxMs() {
  const retryMax = Number(config.spoolerPingRetryMaxMs);
  return Number.isFinite(retryMax) && retryMax > 0
    ? retryMax
    : DEFAULT_RETRY_MAX_MS;
}

function getRequestTimeoutMs() {
  const timeout = Number(config.spoolerPingRequestTimeoutMs);
  return Number.isFinite(timeout) && timeout > 0
    ? timeout
    : DEFAULT_REQUEST_TIMEOUT_MS;
}

function checkSpooler() {
  timer = null;

  if (!isPingEnabled()) {
    store.dispatch("spoolerOffline");
    return;
  }

  if (store.state.user.id) {
    let url = "http://localhost:" + config.printerSpoolLocalPort + "/ping";
    axios
      .post(url, null, { timeout: getRequestTimeoutMs() })
      .then(() => {
        offlineRetryMs = getPingIntervalMs();
        store.dispatch("spoolerOnline");
        setupSpoolerTimeout(offlineRetryMs);
      })
      .catch(() => {
        store.dispatch("spoolerOffline");
        setupSpoolerTimeout(offlineRetryMs);
        offlineRetryMs = Math.min(offlineRetryMs * 2, getRetryMaxMs());
      });
  } else {
    offlineRetryMs = getPingIntervalMs();
    setupSpoolerTimeout(offlineRetryMs);
  }
}

function setupSpoolerTimeout(delayMs) {
  if (timer) clearTimeout(timer);
  const interval =
    Number.isFinite(delayMs) && delayMs > 0 ? delayMs : getPingIntervalMs();
  timer = setTimeout(() => {
    checkSpooler();
  }, interval);
}

checkSpooler();
